import { render, staticRenderFns } from "./RcBonusCalculation.vue?vue&type=template&id=6fbc984b&"
import script from "./RcBonusCalculation.vue?vue&type=script&lang=js&"
export * from "./RcBonusCalculation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports